import { Routes, Route, Navigate } from 'react-router-dom';

import { DevPage } from '@shared/pages'
import { ROUTES_BACKOFFICE } from '@backoffice/constants';
import { Companies, CompanyShow, TerminalList } from '@backoffice/pages';

import { RootLayout } from '@shared/layouts'

import { Sidebar, Header } from './components';

import styles from './backoffice-layout.module.css';

export function BackofficeLayout() {
    const isDev = import.meta.env.DEV;

    return (
        <RootLayout>

            <div className={styles.container}>
                <Header />

                <main className={styles.main}>
                    <Sidebar />

                    <div className={styles.content}>
                        <Routes>
                            <Route path="/" element={<Navigate to={isDev ? ROUTES_BACKOFFICE.DEV.path : ROUTES_BACKOFFICE.COMPANIES.path} replace />} />
                            <Route path={ROUTES_BACKOFFICE.COMPANIES.path} element={<Companies />} />
                            <Route path={ROUTES_BACKOFFICE.COMPANIES.SHOW.path} element={<CompanyShow />} />
                            <Route path={ROUTES_BACKOFFICE.TERMINALS.path} element={<TerminalList />} />
                            {isDev && <Route path={ROUTES_BACKOFFICE.DEV.path} element={<DevPage />} />}
                        </Routes>
                    </div>
                </main>
            </div>
        </RootLayout>
    );
}
